// src/config.js (CRA)
export const API_BASE =
  (process.env.REACT_APP_API_BASE || (window.location.origin ));

